/**
 * EL PANEL AVISA CUANDO HAY VERSION NUEVA (PANEL-VERSION-NUEVA-T1, ASSIGN #17224).
 *
 * QUE PASO. 21-sep: nueve deploys del panel en el dia, y Josse probo dos veces (15:27 y 15:38)
 * sobre el codigo de antes de las 15:00 sin saberlo: la pestana seguia abierta y un SPA no baja el
 * bundle nuevo al navegar. Se ve en api_peticiones: la firma de los tres recorridos viejos. Le pasa
 * igual a cualquier dueno que deja el panel abierto todo el dia.
 *
 * YA HABIA UN AVISO y nunca salto: el de index.html depende de que cambie sw.js, y sw.js tiene su
 * CACHE_VERSION clavado en v2.2.33. Lo que si cambia en cada deploy es /version.json (PANEL-VERSION-T1).
 *
 * LA REGLA: el build graba su commit (__APP_COMMIT__); se compara con el de /version.json. Si el
 * servido es otro, hay version nueva. Nunca se recarga solo: se ofrece.
 *
 * LIMITE DE ARES: como mucho una consulta cada 5 minutos, tambien al volver a la pestana. No se
 * suman peticiones al problema de hoy.
 *
 * Sin DOM: lo prueba scripts/check-version-nueva.mjs.
 */

export const CADA_MS = 5 * 60 * 1000;

/**
 * VISTA-VIEJA-DEPLOY-T1 (Ares #43867, causa en #43873): si /version.json no responde (la ventana del deploy, cuando el
 * service worker sirve el index guardado), se vuelve a preguntar a los 30 s y no a los 5 min: la copia vieja se avisa
 * apenas el servidor vuelve. Una lectura buena deja el freno de 5 minutos como siempre.
 */
export const REINTENTO_MS = 30 * 1000;

/**
 * Si falla la carga de un modulo (vite:preloadError: un pedazo de un build que ya no esta), se recarga una sola vez por
 * build. marca = el commit con que ya se recargo en esta sesion; sin almacenamiento (null de lectura imposible) no se
 * recarga, para no entrar en un ciclo.
 */
/**
 * AVISO-VERSION-CLIENTE-T1 (Josse #43980): el cliente de un negocio no ve avisos de version (muchas no son de su
 * negocio sino del panel). 'boton' para admin y dev (Nexo): el aviso con Recargar. 'silencioso' para todo lo demas
 * (client, manager, member y sin rol): sin aviso; la version nueva entra sola en el siguiente cambio de pantalla.
 */
export function modoDeAviso(rol) {
  return ['admin', 'dev'].includes(texto(rol).toLowerCase()) ? 'boton' : 'silencioso';
}

/** En modo silencioso: se recarga al cambiar de pantalla solo si hay version nueva y nada sin guardar. */
export function puedeRecargarAlNavegar({ pendiente, haySinGuardar }) {
  return !!pendiente && !haySinGuardar;
}

export function debeRecargarPorModulo(marca, commit, hayAlmacenamiento = true) {
  if (!hayAlmacenamiento) return false;
  const c = texto(commit);
  if (!c || c === 'local') return false;
  return texto(marca) !== c;
}

/**
 * Q #43998: un modulo viejo que falla con algo sin guardar (el armador con partidas) NO recarga: se perderia el
 * presupuesto. Se avisa que guarde y vuelva a abrir la pantalla; la marca no se pone, asi que despues de guardar la
 * siguiente falla si recarga. 'recargar' | 'avisar' | 'nada'.
 */
export function queHacerPorModulo({ marca, commit, hayAlmacenamiento = true, haySinGuardar = false }) {
  if (!debeRecargarPorModulo(marca, commit, hayAlmacenamiento)) return 'nada';
  return haySinGuardar ? 'avisar' : 'recargar';
}

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** true si /version.json dice que se sirve otro commit que el que esta corriendo. */
export function hayVersionNueva(corriendo, servida) {
  const mio = texto(corriendo?.commit);
  const alla = texto(servida?.commit);
  // En desarrollo el commit es 'local' o no hay version.json: nunca se avisa.
  if (!mio || !alla || mio === 'local' || alla === 'local') return false;
  return mio !== alla;
}

/**
 * El vigia: revisar(motivo) consulta como mucho una vez cada CADA_MS, pase lo que pase. Cuando
 * encuentra version nueva llama alAviso una sola vez y deja de consultar.
 * @param {{corriendo:{commit:string,version?:string}, leer:()=>Promise<object|null>, alAviso:(servida:object)=>void, ahora?:()=>number}} o
 */
export function crearVigia({ corriendo, leer, alAviso, ahora = () => Date.now() }) {
  let ultima = -Infinity;
  let avisado = false;
  let enCurso = false;
  let consultas = 0;
  let fallo = false;
  // Una lectura fallida adelanta la proxima: la deja posible a los REINTENTO_MS en vez de a los CADA_MS.
  const fallar = (t) => { fallo = true; ultima = t - CADA_MS + REINTENTO_MS; };
  return {
    get consultas() { return consultas; },
    /** true si la ultima lectura no respondio: quien lo monta vuelve a preguntar a los REINTENTO_MS. */
    get fallo() { return fallo; },
    async revisar() {
      if (avisado || enCurso) return false;
      const t = ahora();
      if (t - ultima < CADA_MS) return false;
      ultima = t;
      enCurso = true;
      consultas++;
      try {
        const servida = await leer();
        if (servida === null || servida === undefined) { fallar(t); return false; }
        fallo = false;
        if (hayVersionNueva(corriendo, servida)) {
          avisado = true;
          alAviso(servida);
          return true;
        }
      } catch { fallar(t); /* sin red o sin version.json: se prueba otra vez a los REINTENTO_MS */ }
      finally { enCurso = false; }
      return false;
    }
  };
}
